class OciPagination {
    constructor(total, offset, limit) {
        this.totalEntries = total;
        this.entriesPerPage = limit;
        this.page = offset / limit;
        this.totalPages = Math.ceil(total / limit);
    }
}

module.exports = OciPagination;